import React from 'react';
import Highcharts from 'highcharts';
import { axisSettings, commonSettings } from '../charts.constants';
import { theme } from '../../../../theme/theme';
import { Chart } from '../Chart';
import { mockCategories, mockSeries } from './SplineChart.constants';
import { useChartSettings } from '../hooks/useChartSettings';
import { SplineChartSeries } from './SplineChart';

const chartSettings: Highcharts.Options = {
  ...commonSettings,

  chart: {
    type: 'spline',
  },

  credits: {
    enabled: false,
  },

  title: {
    text: '',
  },

  xAxis: {
    ...commonSettings.xAxis,
    labels: {
      step: 5,
      staggerLines: 1,
      style: {
        fontSize: `${theme.fontSizes.small}px`,
        color: theme.colors.neutral['500'],
        fontWeight: '500',
      },
    },
    categories: mockCategories,
  },

  yAxis: {
    ...commonSettings.yAxis,
    min: 0,
    stackLabels: {
      enabled: false,
    },
    labels: {
      style: {
        fontFamily: theme.fontFamily,
        fontSize: `${theme.fontSizes.small}px`,
        color: theme.colors.neutral['500'],
        fontWeight: '500',
      },
      ...axisSettings.currency.labels,
    },
  },

  legend: {
    enabled: false,
  },

  plotOptions: {
    spline: {
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
  },

  colors: [theme.colors.neutral['300'], theme.colors.neutral['300']],

  tooltip: commonSettings.tooltip,
};

interface SplineChartLoadingProps {
  series?: SplineChartSeries[];
  categories?: string[];
  customSettings?: Record<string, any>;
}

export const SplineChartLoading: React.FC<SplineChartLoadingProps> = ({
  series,
  categories,
  customSettings = {},
}) => {
  const settings = useChartSettings({
    series: series || mockSeries,

    settings: {
      ...chartSettings,
      xAxis: {
        ...chartSettings.xAxis,
        categories,
      },

      tooltip: {
        ...chartSettings.tooltip,
      },
    },

    customSettings,
  });

  return <Chart options={settings} />;
};
